import {reduce} from "@cranq/object-utils";
import {compileDictionaryItem} from "./compileDictionaryItem";

export function compileDictionaryBody(
  compiledKeyValuePairs: Record<string, string>
): string {
  return reduce(compiledKeyValuePairs, (result, value, key) => {
    result.push(compileDictionaryItem(key, value));
    return result;
  }, [] as Array<string>)
    .join(",\n");
}
